<template>
  <div id="app">
    <mdb-navbar color="dark" dark>
      <a href="/">
        <mdb-navbar-brand href="https://virallyze.com/">
          VIRALLYZE 2.0
          <span>(BETA)</span>
        </mdb-navbar-brand>
      </a>
      <mdb-navbar-toggler>
        <mdb-navbar-nav right>
          <span class="tokens"></span>
          <mdb-nav-item
            v-if="isLoggedIn"
            href="/buy-tokens"
            class="text-uppercase"
          >Your tokens: {{ tokens }}</mdb-nav-item>
          <mdb-nav-item
            v-if="isLoggedIn && !instagramAccountConnected"
            href="/fb-auth"
            class="text-uppercase"
          >CONNECT YOUR INSTAGRAM ACCOUNT</mdb-nav-item>
          <mdb-nav-item v-if="isLoggedIn" href="/viral-finder" class="text-uppercase">Viral finder</mdb-nav-item>
          <mdb-nav-item v-if="isLoggedIn" href="/profile-spy" class="text-uppercase">profile spy</mdb-nav-item>
          <mdb-nav-item v-if="isLoggedIn" href="/buy-tokens" class="text-uppercase">Buy tokens</mdb-nav-item>
          <mdb-nav-item v-if="isLoggedIn" href="/profile" class="text-uppercase">PROFILE</mdb-nav-item>
          <mdb-nav-item v-if="!isLoggedIn" href="/" class="text-uppercase">Home</mdb-nav-item>
          <mdb-nav-item v-if="!isLoggedIn" href="/faq" class="text-uppercase">FAQ</mdb-nav-item>
          <mdb-nav-item v-if="!isLoggedIn" href="/login" class="text-uppercase">Log In</mdb-nav-item>
          <mdb-nav-item v-if="isLoggedIn" v-on:click="logout" class="text-uppercase">Logout</mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>
    <div class="page-content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem
} from "mdbvue";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    Footer
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters["user/isLoggedIn"];
    },
    tokens: function() {
      return this.$store.getters["user/user"].tokens;
    },
    instagramAccountConnected: function() {
      const user = this.$store.getters["user/user"];

      if (user === null) {
        return true;
      }

      return (
        user.connectedInstagramAccounts !== null &&
        user.connectedInstagramAccounts.length > 0
      );
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("user/logout").then(() => {
        this.$router.push("/login");
      });
    }
  },
  created: function() {}
};
</script>

<style lang="scss">
$image-path: "~@/../mdb/mdbvue/img";
@import "~@/../mdb/mdbvue/scss/mdb-free.scss";

@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");
</style>
